import type en from "../en/admin";
import type { Messages } from "../../types";

const ar: Messages<typeof en> = {
  breadcrumb: "مسار التنقل",
  navAria: "الإدارة",
  navSectionsAria: "أقسام الإدارة",
  reset: "إعادة تعيين",
  any: "الكل",
  anyone: "أي شخص",
  suspended: "موقوف",
  suspendedReason: "موقوف: {reason}",
  reasonRequired: "يجب ذكر السبب.",
  reasonAuditLabel: "السبب (يُسجَّل في سجل التدقيق)",
  reinstate: "إعادة التفعيل",
  system: "النظام",
  unknown: "غير معروف",
  free: "مجاني",
  perMonth: "{price} / شهريًا",
  perYear: "{price} / سنويًا",
  healthOk: "سليم",
  healthWarn: "تحذير",
  healthError: "خطأ",
  slug: "المعرّف (Slug)",
  currency: "العملة",
  sortOrder: "ترتيب العرض",
  message: "الرسالة",
  sending: "جارٍ الإرسال…",
  scope: "النطاق",
  scope_platform: "المنصة",
  scope_store: "المتجر",
  colStore: "المتجر",
  colOwner: "المالك",
  colPlan: "الخطة",
  colRole: "الدور",
  colUser: "المستخدم",
  colWhen: "التوقيت",
  colActor: "المنفِّذ",
  colAction: "الإجراء",
  colTarget: "الهدف",
  colDetails: "التفاصيل",
  colOrders: "الطلبات",
  colProvider: "المزوّد",
  colAttempts: "المحاولات",
  colLastError: "آخر خطأ",
  colSubject: "الموضوع",
  products: "المنتجات",
  customers: "العملاء",
  market: "السوق",
  joined: "تاريخ الانضمام",
  lastSignIn: "آخر تسجيل دخول",
  platformRole: "الدور على المنصة",
  noAuditEntries: "لا توجد إدخالات تدقيق.",
  overviewTitle: "نظرة عامة على المنصة",
  overviewDesc: "لمحة تشغيلية عن المنصة بأكملها.",
  mUsers: "المستخدمون",
  mUsersSub: "+{d30} خلال آخر 30 يومًا · {suspended} موقوف",
  mActiveMerchants: "التجار النشطون",
  mActiveMerchantsSub: "مالكون لديهم متجر منشور",
  mStores: "المتاجر",
  mLast30: "+{d30} خلال آخر 30 يومًا",
  mSuspendedStores: "المتاجر الموقوفة",
  mErrors24h: "الأخطاء (24 ساعة)",
  revenueTitle: "إيرادات اشتراكات المنصة",
  revenueDesc: "فواتير المنصة المدفوعة فقط (رسوم SaaS).",
  revenueEmpty: "لا توجد فواتير منصة مدفوعة بعد.",
  colLast30: "آخر 30 يومًا",
  colAllTime: "منذ البداية",
  gmvTitle: "مبيعات التجار (GMV) خلال آخر 30 يومًا",
  gmvDesc: "الطلبات المدفوعة غير التجريبية بعد خصم المبالغ المستردة، حسب عملة المتجر.",
  gmvWarnStrong: "مبيعات التجار ليست إيرادات للمنصة.",
  gmvWarnBody: "تُسوّى هذه الأموال مباشرة في حسابات الدفع الخاصة بالتجار.",
  gmvEmpty: "لا توجد طلبات مدفوعة للتجار خلال آخر 30 يومًا.",
  colNetSales: "صافي المبيعات",
  planDistTitle: "توزيع الخطط",
  planDistDesc: "الاشتراكات النشطة والتجريبية والمتأخرة السداد.",
  plansLink: "الخطط ←",
  supportQueueTitle: "قائمة طلبات الدعم",
  openQueueLink: "فتح القائمة ←",
  mOpenPending: "مفتوحة / معلّقة",
  storageInUse: "مساحة تخزين الوسائط المستخدمة: {size}",
  connTitle: "اتصالات الدفع لدى التجار",
  connDesc: "حالة الاتصال فقط — دون أي بيانات اعتماد.",
  catalogueLink: "الكتالوج ←",
  connEmpty: "لا توجد اتصالات دفع للتجار بعد.",
  recentStoresTitle: "أحدث المتاجر",
  allStoresLink: "كل المتاجر ←",
  noStoresYet: "لا توجد متاجر بعد.",
  usersMatching: "الحسابات المطابقة: {n}",
  usersMatching_one: "حساب مطابق واحد",
  usersSearchPlaceholder: "الاسم أو البريد الإلكتروني",
  colStoresOwned: "المتاجر المملوكة",
  unverified: "غير مؤكَّد",
  noUsersMatch: "لا يوجد مستخدمون يطابقون عوامل التصفية هذه.",
  metaUser: "المستخدم",
  suspendUser: "إيقاف المستخدم",
  suspendUserTitle: "إيقاف {email}؟",
  suspendUserBody: "سيُسجَّل خروج المستخدم من جميع الأجهزة ولن يتمكن من تسجيل الدخول حتى تُعاد تفعيله. تبقى متاجره كما هي — أوقف المتاجر بشكل منفصل إذا لزم الأمر.",
  reinstateUser: "إعادة تفعيل المستخدم",
  reinstateUserTitle: "إعادة تفعيل {email}؟",
  reinstateUserBody: "سيتمكن المستخدم من تسجيل الدخول مجددًا.",
  revokeSessions: "إلغاء الجلسات",
  revokeSessionsCount: "إلغاء الجلسات ({count})",
  revokeSessionsTitle: "إلغاء جميع الجلسات؟",
  revokeSessionsBody: "سيُسجَّل خروج المستخدم من جميع الأجهزة.",
  selfAccount: "هذا حسابك الشخصي. يجب أن يُجري مسؤول آخر أي تغيير على الحالة أو الدور.",
  profile: "الملف الشخصي",
  verified: "التأكيد",
  notVerified: "غير مؤكَّد",
  locale: "اللغة والمنطقة",
  sessions: "الجلسات",
  sessionsActive: "النشطة: {n}",
  roleChangeHint: "يؤدي تغيير الدور إلى تسجيل خروج المستخدم.",
  roleSuperOnly: "يمكن للمشرفين العامّين فقط تغيير أدوار المنصة.",
  newRole: "الدور الجديد",
  changeRole: "تغيير الدور",
  changeRoleConfirm: "هل تريد تغيير دور هذا المستخدم على المنصة؟ سيُسجَّل خروجه.",
  subscription: "الاشتراك",
  billing: "الفوترة",
  billingStripe: "Stripe (فوترة المنصة)",
  billingNone: "بلا / مُسنَد يدويًا",
  trialEnds: "نهاية الفترة التجريبية",
  periodEnds: "نهاية الفترة",
  noSubscription: "لا يوجد سجل اشتراك بعد (تُطبَّق الخطة الافتراضية).",
  assignPlanLabel: "إسناد خطة (دون تحصيل دفعة)",
  planInactive: "{name} (غير نشطة)",
  assignPlan: "إسناد الخطة",
  assignAs: "بصفة",
  assignAsActive: "نشطة",
  assignAsTrial: "تجريبية",
  assignPlanConfirm: "هل تريد إسناد هذه الخطة دون تحصيل أي دفعة؟",
  storesRoles: "المتاجر والأدوار",
  notMember: "ليس عضوًا في أي متجر.",
  recentActivity: "النشاط الأخير",
  recentActivityDesc: "إدخالات التدقيق التي كان هذا المستخدم منفِّذها.",
  noActivity: "لا يوجد نشاط مسجَّل.",
  userSuspended: "تم إيقاف المستخدم وتسجيل خروجه.",
  userReinstated: "تمت إعادة تفعيل المستخدم.",
  roleUpdated: "تم تحديث الدور على المنصة. وأُلغيت جلسات المستخدم.",
  planAssigned: "تم إسناد الخطة.",
  sessionsRevoked: "تم إلغاء جميع الجلسات.",
  storesMatching: "المتاجر المطابقة: {n}",
  storesMatching_one: "متجر مطابق واحد",
  storesSearchPlaceholder: "الاسم أو المعرّف",
  colActiveProducts: "المنتجات النشطة",
  colVerifiedDomains: "النطاقات الموثَّقة",
  noStoresMatch: "لا توجد متاجر تطابق عوامل التصفية هذه.",
  metaStore: "المتجر",
  viewStorefront: "عرض واجهة المتجر ↗",
  reinstateStore: "إعادة تفعيل المتجر",
  reinstateStoreTitle: "إعادة تفعيل {name}؟",
  reinstateStoreBody: "يعود المتجر إلى حالة المسودة، ويقرر التاجر متى يعيد نشره.",
  suspendStore: "إيقاف المتجر",
  suspendStoreTitle: "إيقاف {name}؟",
  suspendStoreBody: "ستتوقف واجهة المتجر عن العمل ويتوقف الدفع. تبقى البيانات والطلبات واتصالات الدفع دون أي تغيير.",
  identity: "الهوية",
  publicUrl: "الرابط العام",
  businessType: "نوع النشاط التجاري",
  theme: "القالب",
  ownerPlan: "المالك والخطة",
  ownerStatus: "حالة المالك",
  effectivePlan: "الخطة الفعلية",
  contactEmail: "البريد الإلكتروني للتواصل",
  domains: "النطاقات",
  platformAddressOnly: "عنوان المنصة فقط.",
  primary: "رئيسي",
  paymentConnections: "اتصالات الدفع",
  paymentConnectionsDesc: "الحالة فقط. لا تُحمَّل بيانات الاعتماد ولا تُعرض أبدًا في منطقة الإدارة.",
  colCheckout: "الدفع",
  colMode: "الوضع",
  mode_test: "تجريبي",
  mode_live: "فعلي",
  colLastVerified: "آخر تحقق",
  off: "متوقف",
  noPaymentMethods: "لم يتم إعداد أي وسيلة دفع.",
  storeAuditDesc: "أحدث 25 إدخالًا لهذا المتجر.",
  storeSuspended: "تم إيقاف المتجر.",
  storeReinstated: "أُعيد تفعيل المتجر كمسودة — يمكن للتاجر نشره مجددًا.",
  plansDesc: "خطط الاشتراك في المنصة. خفض الحدود لا يحذف بيانات التجار أبدًا — يحتفظ التجار الذين تجاوزوا الحد ببياناتهم لكن لا يمكنهم إضافة المزيد.",
  newPlan: "خطة جديدة",
  crumbNew: "جديدة",
  metaEditPlan: "تعديل الخطة",
  colFlags: "الوسوم",
  colSubscribers: "المشتركون",
  trialBadge: "فترة تجريبية: {n} يوم",
  limitsSummary: "المتاجر: {stores} · المنتجات: {products} · الموظفون: {staff} · النطاقات: {domains} · {storage}",
  flagDefault: "افتراضية",
  flagActive: "نشطة",
  flagInactive: "غير نشطة",
  flagPublic: "عامة",
  flagHidden: "مخفية",
  flagStripePrice: "سعر Stripe",
  subscribersCount: "المشتركون: {n}",
  subscribersCount_one: "مشترك واحد",
  planCreated: "تم إنشاء الخطة.",
  planChangesInfo: "تُطبَّق التغييرات على جميع المشتركين الحاليين ({n}). خفض الحدود لا يحذف بيانات التجار أبدًا، وتغييرات الأسعار لا تُعدِّل اشتراكات Stripe الحالية ما لم تُغيَّر في Stripe.",
  planChangesInfo_one: "تُطبَّق التغييرات على المشترك الحالي الوحيد. خفض الحدود لا يحذف بيانات التجار أبدًا، وتغييرات الأسعار لا تُعدِّل اشتراكات Stripe الحالية ما لم تُغيَّر في Stripe.",
  planSaved: "تم حفظ الخطة. لا تتأثر بيانات التجار الحالية بتغييرات الحدود.",
  planCode: "الرمز",
  planCodeHint: "أحرف لاتينية صغيرة وأرقام و- و_. يُستخدم في الروابط والفوترة.",
  prices: "الأسعار",
  monthlyPrice: "السعر الشهري",
  monthlyPriceHint: "رقم عشري، مثل 29.00",
  yearlyPrice: "السعر السنوي",
  trialDays: "أيام الفترة التجريبية",
  limits: "الحدود",
  limitsHint: "خفض أي حد لا يحذف بيانات التجار أبدًا — يحتفظ التجار الذين تجاوزوه بما لديهم لكن لا يمكنهم إضافة المزيد.",
  limitStores: "المتاجر",
  limitProducts: "المنتجات / متجر",
  limitStaff: "الموظفون / متجر",
  limitDomains: "النطاقات المخصّصة",
  limitStorage: "التخزين (ميغابايت)",
  features: "الميزات",
  feature_discounts: "رموز الخصم",
  feature_digital_products: "المنتجات الرقمية",
  feature_advanced_analytics: "تحليلات متقدمة",
  feature_abandoned_cart: "تذكيرات السلال المتروكة",
  feature_reviews: "تقييمات المنتجات مع الإشراف",
  feature_custom_domains: "النطاقات المخصّصة",
  feature_team: "حسابات الفريق والأدوار",
  feature_all_themes: "جميع القوالب، بما فيها المميزة",
  feature_priority_support: "دعم ذو أولوية",
  visibilityBilling: "الظهور والفوترة",
  public: "عامة",
  publicHint: "تظهر في صفحة الأسعار وفي أداة اختيار الخطة لدى التجار.",
  defaultPlanActiveHint: "يجب أن تبقى الخطة الافتراضية نشطة.",
  inactivePlanHint: "لا يمكن اختيار الخطط غير النشطة، ويحتفظ بها المشتركون الحاليون.",
  stripePriceMonthly: "معرّف سعر Stripe (شهري)",
  stripePriceYearly: "معرّف سعر Stripe (سنوي)",
  stripePriceHint: "‎price_…‎ من حساب Stripe الخاص بالمنصة. اتركه فارغًا لاستخدام التسعير المضمَّن.",
  createPlan: "إنشاء الخطة",
  savePlan: "حفظ الخطة",
  paymentsTitle: "تكاملات الدفع",
  paymentsDesc: "تكاملات الدفع التي توفرها المنصة للتجار، وكيفية استخدام التجار لها.",
  howTitle: "كيف يعمل توفر وسائل الدفع",
  step1Title: "1 · متاح على المنصة",
  step1Body: "المفتاح الموجود في هذه الصفحة. يحدد ما إذا كان بإمكان التجار إعداد التكامل. يتطلب التقييد ذكر سبب يراه التجار.",
  step2Title: "2 · الإعداد التشغيلي",
  step2Body: "إعدادات على مستوى المنصة تحتاجها بعض الوسائل، مثل تطبيق OAuth الخاص بـ Stripe Connect وسرّ الـ webhook الخاص به (متغيرات البيئة). بدون Connect، يظل بإمكان التجار استخدام مفاتيح Stripe API الخاصة بهم.",
  step3Title: "3 · ربط حساب التاجر",
  step3Body: "يربط كل تاجر حسابه الخاص لدى المزوّد. تُسوّى الأموال لصالح التاجر، ولا تذهب إلى المنصة أبدًا.",
  step4Title: "4 · التفعيل على مستوى المتجر",
  step4Body: "يفعّل التاجر وسيلة الدفع المرتبطة أو يعطّلها في صفحة الدفع الخاصة به.",
  restrictWarning: "تقييد مزوّد لا ينقل مدفوعات أي تاجر ولا يعيد توجيهها ولا يحصّلها أبدًا، ولا يربط حساب أي تاجر أو يعدّله. بل يقتصر على الحد من استخدام هذا التكامل مستقبلًا.",
  catalogueTitle: "كتالوج المزوّدين",
  colImplemented: "مُنفَّذ",
  colOperational: "الإعداد التشغيلي",
  colConnected: "المرتبطون",
  colEnabledCheckout: "مفعَّل عند الدفع",
  colErrors: "الأخطاء",
  colAvailability: "التوفر على المنصة",
  providerKind_online: "إلكتروني",
  providerKind_offline: "غير إلكتروني",
  method_oauth: "OAuth",
  method_api_keys: "مفاتيح API",
  method_offline: "دون اتصال",
  notYetSupported: "غير مدعوم بعد",
  connectOauth: "OAuth لـ Connect:",
  connectWebhook: "Webhook لـ Connect:",
  configured: "مُعَدّ",
  notConfigured: "غير مُعَدّ",
  configuredCap: "مُعَدّ",
  notConfiguredCap: "غير مُعَدّ",
  noneNeeded: "لا يلزم شيء",
  perMerchant: "لكل تاجر (بيانات اعتماده الخاصة)",
  available: "متاح",
  restricted: "مقيَّد",
  platformBilling: "فوترة المنصة",
  platformBillingDesc: "فوترة اشتراكات SaaS الخاصة بـ Storelancer.",
  billingApiKey: "مفتاح API للفوترة",
  billingKeyHint: "لا يمكن إسناد الخطط المدفوعة إلا من قبل المسؤولين حتى يتم تعيين {env}.",
  billingWebhook: "Webhook الفوترة",
  secretConfigured: "السرّ مُعَدّ",
  secretNotConfigured: "السرّ غير مُعَدّ",
  webhookEndpoint: "عنوان نقطة الـ Webhook",
  merchantPaymentsNote: "تستخدم مدفوعات متاجر التجار دائمًا حساب المزوّد المرتبط الخاص بكل تاجر.",
  restrict: "تقييد…",
  restrictionReason: "سبب التقييد (يظهر للتجار)",
  restrictProvider: "تقييد المزوّد",
  makeAvailable: "إتاحته",
  liftRestriction: "رفع التقييد",
  providerAvailable: "أصبح المزوّد متاحًا على المنصة.",
  providerRestricted: "تم تقييد المزوّد. لم يُعَد توجيه مدفوعات التجار الحالية.",
  ticketsByStatus: "التذاكر ({status}): {n}",
  ticketsByStatus_one: "تذكرة واحدة ({status})",
  ticketsOpenPending: "التذاكر المفتوحة أو المعلّقة: {n}، الأكثر إلحاحًا أولًا",
  ticketsOpenPending_one: "تذكرة واحدة مفتوحة أو معلّقة، الأكثر إلحاحًا أولًا",
  statusOpenPending: "مفتوحة + معلّقة",
  pendingAwaiting: "معلّقة (بانتظار مقدّم الطلب)",
  ticketStatus_open: "مفتوحة",
  ticketStatus_pending: "معلّقة",
  ticketStatus_resolved: "محلولة",
  ticketStatus_closed: "مغلقة",
  priority: "الأولوية",
  priority_low: "منخفضة",
  priority_normal: "عادية",
  priority_high: "مرتفعة",
  priority_urgent: "عاجلة",
  category_general: "سؤال عام",
  category_billing: "الخطة والفوترة",
  category_payments: "المدفوعات والتحويلات",
  category_domains: "النطاقات",
  category_technical: "مشكلة تقنية",
  category_account: "الحساب وتسجيل الدخول",
  assignee: "المسؤول عنها",
  assignedToMe: "المسندة إليّ",
  unassigned: "غير مُسندة",
  requester: "مقدّم الطلب",
  colCategory: "الفئة",
  guest: "زائر",
  staff: "فريق العمل",
  queueEmpty: "القائمة فارغة.",
  ticket: "التذكرة",
  ticketDesc: "‏#{number} · {category} · فُتحت في {date}",
  conversation: "المحادثة",
  badgeInternalNote: "ملاحظة داخلية",
  badgeStaffReply: "رد الفريق",
  badgeRequester: "مقدّم الطلب",
  respond: "الرد",
  account: "الحساب",
  viewUser: "عرض المستخدم",
  guestNoAccount: "زائر (بدون حساب)",
  replyToRequester: "الرد على مقدّم الطلب",
  addInternalNote: "إضافة ملاحظة داخلية",
  replyHint: "تُرسل الردود بالبريد الإلكتروني إلى مقدّم الطلب. الملاحظات الداخلية مرئية لفريق العمل فقط.",
  updateTicket: "تحديث التذكرة",
  writeMessageFirst: "اكتب رسالة أولًا.",
  internalNoteAdded: "تمت إضافة الملاحظة الداخلية.",
  replySent: "تم إرسال الرد بالبريد الإلكتروني إلى مقدّم الطلب.",
  ticketUpdated: "تم تحديث التذكرة.",
  contentTitle: "محتوى المنصة",
  contentDesc: "الإعلانات والأسئلة الشائعة ومقالات المساعدة والصفحات القانونية المعروضة على الموقع العام. تحل الصفحات القانونية هنا محل القوالب المدمجة (المعرّفات: terms وprivacy وcookies وacceptable-use).",
  contentDeleted: "تم حذف المحتوى.",
  tab_announcement: "الإعلانات",
  tab_faq: "الأسئلة الشائعة",
  tab_doc: "المستندات",
  tab_legal: "الصفحات القانونية",
  kind_announcement: "إعلان",
  kind_faq: "سؤال شائع",
  kind_doc: "مقالة توثيق",
  kind_legal: "صفحة قانونية",
  colState: "الحالة",
  colOrder: "الترتيب",
  publicLink: "الرابط العام",
  viewExternal: "عرض ↗",
  noContent: "لا يوجد محتوى بعد.",
  newContent: "محتوى جديد",
  metaEditContent: "تعديل المحتوى",
  deleteContentTitle: "حذف «{title}»؟",
  deleteLegalBody: "ستعود الصفحة العامة إلى القالب المدمج.",
  slugHint: "الصفحات القانونية: terms وprivacy وcookies وacceptable-use",
  body: "النص",
  bodyHint: "نص عادي. استخدم «## » للعناوين و«- » للقوائم النقطية وأسطرًا فارغة بين الفقرات. لا يتم عرض HTML.",
  contentCreated: "تم إنشاء «{title}».",
  healthChecked: "تم الفحص في {time}. لا تُعرض قيم الإعدادات والأسرار هنا أبدًا.",
  colCheck: "الفحص",
  colDetail: "التفاصيل",
  eventsTitle: "أحداث النظام الأخيرة",
  eventsDesc: "آخر 50 حدثًا من العمليات الخلفية والـ webhooks والتطبيق.",
  colLevel: "المستوى",
  colSource: "المصدر",
  noEvents: "لا توجد أحداث نظام مسجّلة.",
  failedJobsTitle: "المهام الخلفية الفاشلة",
  failedJobsDesc: "المهام التي استنفدت محاولات إعادة التنفيذ.",
  colFinished: "انتهت في",
  noFailedJobs: "لا توجد مهام فاشلة.",
  auditDesc: "الإجراءات الحساسة على المنصة والمتاجر، الأحدث أولًا.",
  auditSearchLabel: "الإجراء أو بريد المنفِّذ أو معرّف الهدف",
  auditSearchPlaceholder: "مثال: {example}",
  storeLink: "المتجر",
  noAuditMatch: "لا توجد إدخالات تدقيق مطابقة.",
  paginationAria: "التنقل بين الصفحات",
  pageN: "الصفحة {page}",
  newer: "الأحدث",
  older: "الأقدم",
  emailsDesc: "آخر 100 رسالة بريد إلكتروني صادرة — البيانات الوصفية فقط. لا يُعرض نص الرسائل أبدًا لأنه قد يحتوي على روابط إعادة تعيين كلمة المرور أو روابط تنزيل.",
  colQueued: "وقت الإدراج",
  colTo: "المستلم",
  colTemplate: "القالب",
  loggedNoSmtp: "مُسجَّل (بدون SMTP)",
  noEmails: "لا توجد رسائل بريد إلكتروني بعد.",
};

export default ar;
